import api from 'config/api';

export default {
  healthCheck: () => api.get('health_check/all'),
  getConfig: () => api.get(`api/v1/utilities/configuration`),
  utilityHealthCheck: () => api.get('api/v1/utilities/healthcheck')
};
